import { render, staticRenderFns } from "./AtlasDetail.vue?vue&type=template&id=3aa43612&scoped=true&"
import script from "./AtlasDetail.vue?vue&type=script&lang=js&"
export * from "./AtlasDetail.vue?vue&type=script&lang=js&"
import style0 from "./AtlasDetail.vue?vue&type=style&index=0&id=3aa43612&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa43612",
  null
  
)

export default component.exports